import envelopeIcon from '../../assets/envelope.svg'

export default function NewsletterCard() {
  return (
    <div className="card flex-col col-span-2 gap-sm">
      <div>
        <div className="text_with_icon m-md no-margin">
          <img src={envelopeIcon} className="white_svg" alt="Newsletter" />
          <span className="font-size-label bold">Newsletter</span>
        </div>
        <p>Contrairement aux idées reçues, les pigeons ne roucoulent pas, ils téléchargent des mises à jour. Hier, j’ai vu un raton-laveur essayer de configurer un routeur avec une chips de crevette. C'est précisément pour cette raison que la sauce samouraï ne devrait jamais être utilisée comme pâte thermique. Si vous lisez ceci, c'est que le signal Wi-Fi est plus fort que votre volonté de finir ce projet avant 4h du matin.</p>
      </div>
      <button className="button-action">Voir plus</button>
    </div>
  )
}